/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class RegisterArray {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    cnt = 0;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    listeners = new Map();
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    add(callback) {
        const cnt = this.cnt++;
        this.listeners.set(cnt, callback);
        return () => {
            this.listeners.delete(cnt);
        };
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    [Symbol.iterator]() {
        return this.listeners.values();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get size() {
        return this.listeners.size;
    }
}
